import axios from "axios";
import { useEffect, useState } from "react";
import { Alert, Button, Container, Form, Modal, Table, Spinner } from "react-bootstrap";
import getAPI from "../../service/getAPI";
import { format } from "date-fns";

const AssignList = ({ search, setSearch }) => {
  const { master } = getAPI();
  const [inquiries, setInquiries] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(() => {
    const saved = localStorage.getItem("pageLimit");
    return saved ? parseInt(saved, 10) : 10;
  });

  useEffect(() => {
    localStorage.setItem("pageLimit", limit);
  }, [limit]);

  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [selectedInquiry, setSelectedInquiry] = useState(null);
  const [modalType, setModalType] = useState("");
  const [orderList, setOrderList] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [refundAmount, setRefundAmount] = useState("");
  const [refundMethod, setRefundMethod] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  // const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isFetchingOrders, setIsFetchingOrders] = useState(false);
  const [modalError, setModalError] = useState("");
  const [remark, setRemark] = useState("");
  const [remarksList, setRemarksList] = useState([]);
  const [orderFetchError, setOrderFetchError] = useState("");
  const [orderFetchSuccess, setOrderFetchSuccess] = useState("");


  useEffect(() => {
    fetchInquiries();
  }, [page, limit, search, fromDate, toDate]);

  const fetchInquiries = async () => {
    setLoading(true);
    try {
      const response = await axios.post(master.assignInquiryList, {
        page,
        limit,
        search,
        from_date: fromDate,
        to_date: toDate,
      });
      const result = response.data?.data;
      console.log(result);
      setInquiries(result?.data || []);
    } catch (err) {
      setError("Failed to fetch inquiries.");
    } finally {
      setLoading(false);
    }
  };

  const fetchOrdersByMobile = async () => {
    try {
      setIsFetchingOrders(true);
      setOrderFetchError("");
      setOrderFetchSuccess("");

      if (!mobileNumber || mobileNumber.length !== 10) {
        setOrderFetchError("Please enter a valid 10-digit mobile number");
        return;
      }

      // Clear validation error if 10 digits are entered
      setOrderFetchError("");

      const response = await axios.post(master.getmobileorderlist, {
        order_mobile_no: mobileNumber,
      });

      if (response.data?.data?.length === 0) {
        setOrderFetchError("No orders found for the given mobile number.");
        setOrderList([]);
        return;
      }

      setOrderList(response.data?.data || []);
      setOrderFetchSuccess(`Found ${response.data.data.length} order(s) for this mobile number show in below dropdown `);

    } catch (err) {
      console.error(err);
      setOrderFetchError("Failed to fetch order list. Please try again.");
    } finally {
      setIsFetchingOrders(false);
    }
  };

  const handleSubmitRecourier = async () => {
    if (!selectedOrder || !selectedInquiry?.inquiry_id) return;

    try {
      await axios.post(master.sendInquiryRecourier, {
        inquiry_id: selectedInquiry.inquiry_id,
        order_mobile_no: mobileNumber,
        order_code: selectedOrder.order_code,
      });
      setSuccess("Recourier request sent successfully.");
      setModalType("");
      setInquiries((prev) =>
        prev.map((i) =>
          i.inquiry_id === selectedInquiry.inquiry_id
            ? { ...i, resolution_type: "recourier" }
            : i
        )
      );
      fetchInquiries(page, limit);
    } catch (err) {
      console.error(err);
      setError("Failed to send recourier.");
    }
  };


  const handleSubmitRefund = async () => {
    if (!selectedOrder || !refundMethod || !refundAmount || !selectedInquiry?.inquiry_id) return;

    try {
      await axios.post(master.sendInquiryRefund, {
        inquiry_id: selectedInquiry.inquiry_id,
        order_mobile_no: mobileNumber,
        order_code: selectedOrder.order_code,
        refund_amount: parseFloat(refundAmount),
        refund_method: refundMethod,
      });
      setSuccess("Refund processed successfully.");
      setModalType("");
      setInquiries((prev) =>
        prev.map((i) =>
          i.inquiry_id === selectedInquiry.inquiry_id
            ? { ...i, resolution_type: "refund" }
            : i
        )
      );
      fetchInquiries(page, limit);
    } catch (err) {
      console.error(err);
      setError("Failed to process refund.");
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    fetchInquiries();
  };

  const handleReset = () => {
    setSearch("");
    setFromDate("");
    setToDate("");
    setPage(1);
    fetchInquiries();
  };

  const formatDateTime = (utcDateStr) => {
    if (!utcDateStr) return '-';
    const date = new Date(utcDateStr);
    // Offset IST: UTC + 5 hours 30 minutes = 330 minutes
    const istOffset = 330 * 60 * 1000;
    const istDate = new Date(date.getTime() + istOffset);

    return istDate.toLocaleString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };

  const handleOpenModal = (type, inquiry) => {
    // Reset all modal-related states first
    handleCloseModal();

    // Set the new modal type
    setModalType(type);

    if (!inquiry || !inquiry.inquiry_id) {
      setError("Invalid query selected.");
      return;
    }

    // Set the selected inquiry
    setSelectedInquiry(inquiry);

    // For attempt modal, set mobile number and fetch remarks
    if (type === 'attempt') {
      setMobileNumber(inquiry.order_mobile_no || "");
      setRemark("");
      setRemarksList([]);
    } else {
      // For other modals (recourier, refund), clear mobile number and order list
      setMobileNumber("");
      setOrderList([]);
      setOrderFetchError("");
      setOrderFetchSuccess("");
      setSelectedOrder(null);
      fetchOrdersByMobile();
    }

    // Reset other form fields
    setRefundAmount("");
    setRefundMethod("");
  };

  const handleCloseModal = () => {
    // Reset all modal-related states
    setModalType("");
    setSelectedInquiry(null);
    setSelectedOrder(null);
    setMobileNumber("");
    setRemark("");
    setRemarksList([]);
    setRefundAmount("");
    setRefundMethod("");
    setModalError("");
    setOrderList([]);
    setOrderFetchError("");
    setOrderFetchSuccess("");
    setIsFetchingOrders(false);
  };

  return (
    <Container fluid>
      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">{success}</Alert>}

      <div className="card mb-4">
        <div className="card-body">
          <Form onSubmit={handleSearch}>
            <div className="row">
              <div className="col-md-3">
                <Form.Control
                  placeholder="Search..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <Form.Control
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <Form.Control
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  min={fromDate}
                />
              </div>
              <div className="col-md-3 d-flex gap-2">
                <Button type="submit" variant="primary">Search</Button>
                <Button onClick={handleReset} variant="secondary">Reset</Button>
              </div>
            </div>
          </Form>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          {loading ? (
            <div className="text-center"><Spinner /></div>
          ) : (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Assigned To</th>
                  <th>Remark</th>
                  <th>Assigned Date</th>
                  <th>Inquiry Date</th>
                  {/* <th>Status</th> */}
                  <th>Priority</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {inquiries.map((inquiry, index) => (
                  <tr key={inquiry.inquiry_id}>
                    <td>{(page - 1) * limit + index + 1}</td>
                    <td>{inquiry.customer_name || '-'}</td>
                    <td>{inquiry.order_mobile_no || '-'}</td>
                    <td>{inquiry.emp_name || '-'}</td>
                    <td>{inquiry.inquiry_remark || '-'}</td>
                    <td>{inquiry.assigned_date
                      ? format(new Date(inquiry.assigned_date), "dd-MM-yyyy hh:mm a")
                      : "N/A"}</td>
                    <td>{inquiry.created_at
                      ? format(new Date(inquiry.created_at), "dd-MM-yyyy hh:mm a")
                      : "N/A"}</td>
                    {/* <td>
                      <span className={`badge bg-${inquiry.status === 'resolved' ? 'success' : 'warning'}`}>
                        {inquiry.status || 'pending'}
                      </span>
                    </td> */}
                    {/* <td>
                      <span
                        className="badge"
                        
                        style={{
                          backgroundColor: inquiry.assigned_colourcode,
                          color: '#000', // black text works well for yellow and orange; can be made dynamic
                        }}
                      >
                        {inquiry.is_resolved ? 'Resolved' : 'Pending'}
                      </span>
                    </td> */}

<td>
                      <span
                        className="badge"
                        style={{
                          backgroundColor:
                            inquiry.PRIORITY === "LOW"
                              ? "yellow"
                              : inquiry.PRIORITY === "MEDIUM"
                                ? "orange"
                                : inquiry.PRIORITY === "HIGH"
                                  ? "red"
                                  : "gray",
                          color: inquiry.PRIORITY === "LOW" ? "black" : "white",
                          padding: "5px 10px",
                          borderRadius: "6px",
                          fontWeight: "bold"
                        }}
                      >
                        {inquiry.PRIORITY || "-"}
                      </span>
                    </td>

                    <td>
                      <div className="d-flex gap-1">
                        <Button
                          variant="info"
                          size="sm"
                          className="text-nowrap border-0"
                          style={{ backgroundColor: '#0dcaf0' }}
                          onClick={() => handleOpenModal('recourier', inquiry)}
                        >
                          Recourier
                        </Button>
                        <Button
                          variant="warning"
                          size="sm"
                          className="text-nowrap border-0"
                          style={{ backgroundColor: '#ffc107' }}
                          onClick={() => handleOpenModal('refund', inquiry)}
                        >
                          Refund
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}

          <div className="d-flex justify-content-between align-items-center mt-3">
            <div>Total Records: {totalRecords}</div>
            <div className="d-flex align-items-center">
              <Form.Label className="me-2 mb-0">Show:</Form.Label>
              <Form.Select
                value={limit}
                onChange={(e) => {
                  setLimit(Number(e.target.value));
                  setPage(1);
                }}
                style={{ width: "100px" }}
              >
                {[10, 25, 50, 100].map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </Form.Select>
              <Button className="mx-2" disabled={page === 1} onClick={() => setPage(page - 1)}>
                &laquo; Prev
              </Button>
              <Form.Select
                value={page}
                onChange={(e) => setPage(Number(e.target.value))}
                style={{ width: "100px" }}
              >
                {Array.from({ length: totalPages }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    Page {i + 1}
                  </option>
                ))}
              </Form.Select>
              <Button
                className="mx-2"
                disabled={page === totalPages}
                onClick={() => setPage(page + 1)}
              >
                Next &raquo;
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Modal show={modalType === "recourier" || modalType === "refund"} onHide={() => setModalType("")}>
        <Modal.Header closeButton>
          <Modal.Title>
            {modalType === "recourier" ? "Send Recourier" : "Process Refund"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* here i want to write mobile number manually and click get details button  but here already fetch number that i don't want to fetch */}

          <Form.Group className="mb-3">
            <Form.Label>Mobile Number</Form.Label>
            <Form.Control
              type="text"
              value={mobileNumber || ""}
              onChange={(e) => {
                setMobileNumber(e.target.value);
                // Clear validation error when input changes
                if (e.target.value.length === 10) {
                  setOrderFetchError("");
                }
              }}
              placeholder="Enter mobile number"
            />
          </Form.Group>
          {isFetchingOrders && (
            <div className="text-center mb-3">
              <Spinner animation="border" size="sm" /> Fetching orders...
            </div>
          )}
          {orderFetchError && (
            <Alert variant="danger" className="mb-3">
              {orderFetchError}
            </Alert>
          )}
          {orderFetchSuccess && (
            <Alert variant="success" className="mb-3">
              {orderFetchSuccess}
            </Alert>
          )}
          {mobileNumber.length === 10 && (
            <div className="text-end mb-3">
              <Button
                variant="primary"
                onClick={fetchOrdersByMobile}
                className="px-4"
                disabled={isFetchingOrders}
              >
                Get Details
              </Button>
            </div>
          )}
          <Form.Group className="mb-3">
            <Form.Label>Select Order</Form.Label>
            <Form.Select
              value={selectedOrder?.order_code || ""}
              onChange={(e) => {
                const selected = orderList.find(
                  (o) => o.order_code === String(e.target.value)
                );
                setSelectedOrder(selected);
                if (modalType === "refund" && selected) {
                  setRefundAmount();
                }
              }}
            >
              <option value="">-- Select --</option>
              {orderList.map((order) => (
                <option
                  key={order.order_code}
                  value={order.order_code}
                >
                  {`${order.order_code} - ${order.customer_name} - ${order.product}`}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {modalType === "refund" && (
            <>
              <Form.Group className="mt-3">
                <Form.Label>Refund Amount</Form.Label>
                <Form.Control
                  type="number"
                  value={refundAmount}
                  onChange={(e) => setRefundAmount(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mt-3">
                <Form.Label>UPI No.</Form.Label>
                <Form.Control
                  type="text"
                  value={refundMethod}
                  onChange={(e) => setRefundMethod(e.target.value)}
                  placeholder="e.g. 7894561230"
                />
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalType("")}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={
              modalType === "recourier" ? handleSubmitRecourier : handleSubmitRefund
            }
            disabled={!selectedOrder || (modalType === "refund" && !refundAmount)}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AssignList;